import axios from "axios";

const axiosInstance = axios.create({
  responseType: "json",
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers:
    process.env.NODE_ENV === "development" && !process.env.NEXT_PUBLIC_DEV_ENV
      ? {
          "Local-Authorization": process.env.NEXT_PUBLIC_LOCAL_AUTHORIZATION,
          "Accept-Language": "pl",
        }
      : { "Accept-Language": "pl" },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(
        "Błąd odpowiedzi:",
        error.response.status,
        error.response.data
      );
    } else if (error.request) {
      console.error("Błąd żądania:", error.request);
    } else {
      console.error("Błąd:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
